// extracted by mini-css-extract-plugin
module.exports = {"regionGroup":"styles-module--regionGroup--1D-Yy"};